/**
 * belfastpilates-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.BelfastpilatesProductionappspotcom) {
      root.BelfastpilatesProductionappspotcom = {};
    }
    root.BelfastpilatesProductionappspotcom.RuleBean = factory(root.BelfastpilatesProductionappspotcom.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The RuleBean model module.
   * @module model/RuleBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>RuleBean</code>.
   * @alias module:model/RuleBean
   * @class
   */
  var exports = function() {
    var _this = this;











  };

  /**
   * Constructs a <code>RuleBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RuleBean} obj Optional instance to populate.
   * @return {module:model/RuleBean} The populated <code>RuleBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('dateCreated')) {
        obj['dateCreated'] = ApiClient.convertToType(data['dateCreated'], 'Date');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('lastUpdatedDateTime')) {
        obj['lastUpdatedDateTime'] = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      }
      if (data.hasOwnProperty('numberOfDaysToGenerateJobs')) {
        obj['numberOfDaysToGenerateJobs'] = ApiClient.convertToType(data['numberOfDaysToGenerateJobs'], 'String');
      }
      if (data.hasOwnProperty('searchId')) {
        obj['searchId'] = ApiClient.convertToType(data['searchId'], 'String');
      }
      if (data.hasOwnProperty('useBankHolidays')) {
        obj['useBankHolidays'] = ApiClient.convertToType(data['useBankHolidays'], 'Boolean');
      }
      if (data.hasOwnProperty('useEmployeeAvailability')) {
        obj['useEmployeeAvailability'] = ApiClient.convertToType(data['useEmployeeAvailability'], 'Boolean');
      }
      if (data.hasOwnProperty('useEmployeeHolidays')) {
        obj['useEmployeeHolidays'] = ApiClient.convertToType(data['useEmployeeHolidays'], 'Boolean');
      }
      if (data.hasOwnProperty('useWorkingWeek')) {
        obj['useWorkingWeek'] = ApiClient.convertToType(data['useWorkingWeek'], 'Boolean');
      }
      if (data.hasOwnProperty('userId')) {
        obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {Date} dateCreated
   */
  exports.prototype['dateCreated'] = undefined;
  /**
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype['lastUpdatedDateTime'] = undefined;
  /**
   * @member {String} numberOfDaysToGenerateJobs
   */
  exports.prototype['numberOfDaysToGenerateJobs'] = undefined;
  /**
   * @member {String} searchId
   */
  exports.prototype['searchId'] = undefined;
  /**
   * @member {Boolean} useBankHolidays
   */
  exports.prototype['useBankHolidays'] = undefined;
  /**
   * @member {Boolean} useEmployeeAvailability
   */
  exports.prototype['useEmployeeAvailability'] = undefined;
  /**
   * @member {Boolean} useEmployeeHolidays
   */
  exports.prototype['useEmployeeHolidays'] = undefined;
  /**
   * @member {Boolean} useWorkingWeek
   */
  exports.prototype['useWorkingWeek'] = undefined;
  /**
   * @member {String} userId
   */
  exports.prototype['userId'] = undefined;



  return exports;
}));





// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/RuleBean.js